import { render, staticRenderFns } from "./LoaderKaik.vue?vue&type=template&id=2abb068d&scoped=true"
import script from "./LoaderKaik.vue?vue&type=script&lang=js"
export * from "./LoaderKaik.vue?vue&type=script&lang=js"
import style0 from "./LoaderKaik.vue?vue&type=style&index=0&id=2abb068d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abb068d",
  null
  
)

export default component.exports